import { IonButton, IonIcon, useIonToast } from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { selectUserRoles } from "../../../store/supervisorHome/selectors/selectUserRoles";
import { sendFileForSign } from "../../../store/supervisorRequiredDocuments/actions/sendFileForSign";
import { selectFindHojaDeCargo } from "../../../store/supervisorRequiredDocuments/selectors/selectFindHojaDeCargo";
import { findHojaDeCargo } from "../../../store/supervisorRequiredDocuments/actions/findHojaDeCargo";

const normalizeRut = (val?: string | number) => {
  if (val == null) return "";
  return String(val)
    .replace(/[^0-9kK]/g, "") // quita puntos, guion, espacios y deja números/K
    .replace(/^0+/, "");      // quita ceros a la izquierda
};

export const SendForSignBtn = ({ hcId }: any) => {
  const hojasDeCargo = useSelector(selectFindHojaDeCargo);
  const users = useSelector(selectUserRoles);

  const dispatch = useDispatch();
  const [presentToast, hideToast] = useIonToast();

  const statusDigitalSignature: string | null =
    hojasDeCargo?.[0]?.hojaCargo?.statusDigitalSignature ?? null;

  // RUT de la hoja de cargo normalizado (sin puntos/guion/ceros izq)
  const rutHCNorm = normalizeRut(hojasDeCargo?.[0]?.hojaCargo?.personalRut);

  // Busca stakeholder por DNI normalizado
  const stakeHolderId = Array.isArray(users)
    ? users.filter((u: any) => normalizeRut(u?.user?.dni) === rutHCNorm)
    : [];

  const isPending = statusDigitalSignature === "Pendiente";
  const hasStakeholder = (stakeHolderId?.length ?? 0) > 0;

  // Regla clara: habilitar solo si está pendiente y existe stakeholder

  const isDisabled = !(isPending && hasStakeholder);
  console.log({ statusDigitalSignature, rutHCNorm,
    usersSample: users?.slice?.(0,3)?.map(u => normalizeRut(u?.user?.dni)),
    hasStakeholder });

  const handleSendNotificationTest = async (hcId: any) => {
    try {
      await hideToast();
      presentToast({ message: `Generando proceso...`, color: "primary" });

      const { payload }: any = await dispatch(sendFileForSign(hcId));
      if (!payload) throw new Error("No se pudo generar el proceso");

      await hideToast();
      presentToast({
        message: `La hoja de cargo se envió correctamente a firmar`,
        color: "success",
        duration: 8000,
      });
      dispatch(findHojaDeCargo(hcId));
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema al enviar a firma",
        color: "danger",
        duration: 8000,
      });
    }
  };

  return (
    <IonButton
      color="secondary"
      size="large"
      onClick={() => handleSendNotificationTest(hcId)}
      disabled={isDisabled}
    >
      <IonIcon icon={createOutline} slot="start" />
      <span>Enviar a Firma</span>
    </IonButton>
  );
};
